<template>
    <div id="chatZoneMenuContainer" >
        <h1 class="title">채팅</h1>
      <div class="channel-list">
        <chatZoneMenuItems v-for="(item, index) in chatZoneArray" :key="index" :item="item" />
      </div>
      <div class="extension-menu left-chat-header-menu-box ">
        <chatSettingMenu id="chatSettingMenu" />
      </div>
    </div>
</template>

<script>
import chatZoneMenuItems from './chat-zone-menu-item'
import chatSettingMenu from './chat-setting-menu-new'

export default {
  props: [
    'chatZoneArray'
  ],
  components: {
    'chatSettingMenu': chatSettingMenu,
    'chatZoneMenuItems': chatZoneMenuItems
  },
  mounted: function () {
    // prevent ctrl + click
    var chatZoneIconList = document.querySelectorAll('.chatZoneLink')
    for (const i in chatZoneIconList) {
      if (chatZoneIconList.hasOwnProperty(i)) {
        const elem = chatZoneIconList[i]
        elem.addEventListener('click', function (event) {
          if (event.ctrlKey) {
            event.preventDefault()
            var url = location.href
            location.href = url.slice(0, url.lastIndexOf('/') + 1) + this.getAttribute('rel')
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">

#chatZoneMenuContainer {
  z-index:1000;
  position: fixed;
  padding:  0 20px;
  box-sizing: border-box;
  width: 100%; // border-right 살리기 위해서 사용
  height: 69px;
  box-shadow: 0px 0px 6px 0px #e6e6e6;

  h1.title {
    display:inline-block;
    font-family:'맑은 고딕', sans-serif;
    font-size:15px;
    font-weight: 600;
    letter-spacing: -1px;
    margin: 0;
    vertical-align: middle;
  }

  .extension-menu {
    display: inline-block;
    line-height: 69px;
  }

  .channel-list {
    height: 100%;
    float: right;
    margin-right: -10px;
  }

  // .user-count-icon {
  //   background: var(--sport-chat-icon) -83px -122px /225px 199px;
  // }

}
</style>



// WEBPACK FOOTER //
// chat-zone-menu.vue?e49a3734